export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "estimated_harvest": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosecha estimada"])},
            "weight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peso"])},
            "num_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de empaques"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
            "crop_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo"])},
            "harvest_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de cosecha"])},
            "harvest_process_crop_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaque de cosecha"])},
            "crop_field_sector": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sector"])}
          }
        }
      }
    }
  })
}